/**
 * Created by fers on 05.02.16.
 */
/* global Uint8Array */
import Token from '../../../packages/extension/src/background/Token';
import {sendError} from '../app/errorDisplayer';
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import filesaver from 'filesaver.js';

import Link from 'react-router/lib/Link';
import {declareEditEntity} from '../../common/fw/MetaDataHelper.ts';
import ChannelIcon from '../channel-defs/ChannelIcon.react';
import {injectIntl, FormattedMessage, FormattedHTMLMessage, defineMessages, IntlShape} from 'react-intl';
import {sendToExtension} from '../app/ExtensionCommunicate';
import {EditorWithSubmit} from '../fw/EditorWithSubmit.react';
import TestChannelAuthMutation from './TestChannelAuthMutation.react';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import config from '../../common/config';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import UpdateChannelAuthMutation from './UpdateChannelAuthMutation.react';
import ScenarioBoxAsWizard from '../scenarios/ScenarioBoxAsWizard.react';
import ScenarioIcon from '../scenarios/ScenarioIcon.react';
import "../scenarios/Scenario.scss";
import * as Tool from '../fw/Tool';
import ScenarioWizard from '../scenarios/ScenarioWizard.react';
import {getLocale} from '../locales';
import mutationError from '../channel-defs/mutationError';
import {AUTH_TYPE_PER_USER} from "../../common/model-api/ChannelDefType";
import {safeJSONparse} from "../../common/util/safeJSONparse";
import {getQueryParams} from '../../common/util/QueryParams';
import AcceptLinkInvitationMutation from './AcceptLinkInvitationMutation';
import AgentLink from '../fw/AgentLink.react';
import UpdateChannelConfigMutation from './UpdateChannelConfigMutation.react';
import * as Instanced from '../../standalone/instanceHelper';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import InvokeChannelActionMutation from '../channels/InvokeChannelActionMutation.react';
import * as BrowserPermission from '../BrowserPermission';
import * as Permission from '../../common/util/Permission';
import {CONFIG_STEP_1, CONFIG_STEP_2, CONFIG_STEP_3} from '../../common/model-api/ChannelOptionDefType';
import LoadingButton from '../fw/LoadingButton.react';
import { ACCESS_TYPE_DEVELOPER, ACCESS_TYPE_PARTNER1, ACCESS_TYPE_PARTNER2 } from '../../common/model-api/UserType';
import { User } from '../../common/types/types';
import {getNextChannelCreateStep} from './channelCreateSteps';

const messages = defineMessages({
    example: {id: 'channelOptionEdit.example', 'defaultMessage': 'Example:'},
    filled: {id: 'channelOptionEdit.authInfo.filled', 'defaultMessage': '(Filled - overwrite by entering text)'},
    title: {id: 'channelOptionEdit.title', 'defaultMessage': 'Editing application option'},
    save: {id: 'action.saveOptions', 'defaultMessage': 'Save options'},
    connect: {id: 'action.connect', 'defaultMessage': 'Connect'},
    options: {id: 'channelOptionEdit.options', 'defaultMessage': 'Options'},
    agentInvitationId: {id: 'channelOptionEdit.agentInvitationId', 'defaultMessage': 'Agent Invitation ID'},
    useDativeryAgent: {id: 'channelOptionEdit.useDativeryAgent', 'defaultMessage': 'Use {productName} Agent'},
    agentInvitationDescription: {id: 'channelOptionEdit.agentInvitationDescription', 'defaultMessage': 'An ID you can receive by invitation in {productName} Agent.'},
    agentInvitationDescription2: {id: 'channelOptionEdit.agentInvitationDescription2', 'defaultMessage': 'Optionally you can use {productName} Agent to connect to application.'},
    next: {id: 'action.next', defaultMessage: 'Next'},
    fetchListLink: {id: 'channelOptionEdit.fetchListLink', defaultMessage: 'Open API request history'},
});

let handleJavaScript = (script, values, isBoolean, prefix) => {
    return (data, columnPrefixId) => {
        try {
            // eslint-disable-next-line no-unused-vars
            function getValue(field) { // this function can be used in 'eval'
                if ((prefix + field) in data) {
                    return data[prefix + field];
                }
                return undefined;
            }
            // eslint-disable-next-line no-unused-vars
            let getOptionValue = getValue; // this function can be used in 'eval'

            let output = null;
            // eslint-disable-next-line no-unused-vars
            let json = values; // accessible in eval

            const staticPrefix = "output = (function userScript () { ";
            const staticSuffix = "\nreturn output; })();";

            // eslint-disable-next-line no-eval
            let result = eval(staticPrefix + script + staticSuffix); // we need this :-( it is invoked in browser // nosemgrep

            if (result === undefined && output !== null) {
                result = output;
            }

            if (isBoolean) {
                return result ? true : false;
            } else {
                return result;
            }
        } catch (e) {
            console.error("Error in handleJavaScript", script, e);
            throw e;
        }
    };
};


interface ChannelOptionEditProps {
 cancel?: (...args: unknown[]) => unknown | boolean;
 createCallback?: (...args: unknown[]) => unknown;
 intl: IntlShape;
 relay: object;
 step?: number;
 user: User;
 wrapper?: boolean;
}


export class ChannelOptionEdit extends React.Component<ChannelOptionEditProps> {

    static propTypes = {
        cancel: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
        createCallback: PropTypes.func,
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        step: PropTypes.number,
        user: PropTypes.object.isRequired,
        wrapper: PropTypes.bool
    };

    static defaultProps = {
        wrapper: false
    };

    typeName = 'channels';
    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props) {
        super(props);

        this.args = document.location.search ? getQueryParams(document.location.search) : {};

        this.state = {
            authTestInProgress: false,
            hasAuthTest: false,
            authFailureSuccess: true,
            authFailureMessage: '',
            hasConfigResult: false,
            configFailureSuccess: true,
            configFailureMessage: '',
            attempts: 0,
            fetch: null,
            fetchedValues: {},
            step: this.getFirstStep(props),
            fetching: false,
            fetched1: false,
            fetched2: false,
            fetched3: false,
            invitationId: this.args.invitationId || ''
        };

        let channelDef = this.props.user.organisation.channel.channelDef;

        let {channel} = this.props.user.organisation;
        let {options, authOptions, currentUserOptions} = channel;

        let parsedOptions = safeJSONparse(options);
        if (channelDef.canUseAgent) {
            if (channel.agentLink) {
                parsedOptions['can-use-dativery-agent'] = true;
            } else {
                parsedOptions['can-use-dativery-agent'] = false;
            }
        }

        /* we receive options as JSON string */
        this.originalOptions = this.mapKeys(channelDef, { ...parsedOptions, ...safeJSONparse(currentUserOptions) });
        this.originalAllOptions = this.mapKeys(channelDef, { ...parsedOptions, ...safeJSONparse(authOptions), ...safeJSONparse(currentUserOptions) });

        this.prepareMetaData();

        Instanced.getInstanceHelper().then((funcs) => {
            this.instanceFuncs = funcs;

        }).catch(() => {});
    }

    prepareMetaData() {
        if (!this.metadata) {
            let channelDef = this.props.user.organisation.channel.channelDef;
            let {allChannelOptionDefs} = channelDef;

            this.metadata = this.collectMetaData(channelDef, allChannelOptionDefs.edges.map(({node}) => node).filter((cod) => !cod.disabled), this.originalAllOptions);
        }
    }

    getTypeKey(channelDef) {
        return channelDef['type'].replace(/[^a-z^0-9]+/ig, "-") + "-";
    }

    mapKeys(channelDef, options) {
        let result = {};
        let prefix = this.getTypeKey(channelDef);

        for (let key of Object.keys(options)) {
            result[prefix + key] = options[key];
        }

        return result;
    }

    unmapKeys(channelDef, data) {
        let result = {};
        let prefix = this.getTypeKey(channelDef);

        for (let key of Object.keys(data)) {
            let origKey = key;
            if (key.startsWith(prefix)) {
                key = key.substring(prefix.length);
            }
            result[key] = data[origKey];
        }

        return result;
    }

    collectMetaData(channelDef, channelOptionDefs, originalData) {
        let list = {};
        let prefix = this.getTypeKey(channelDef);

        if (channelDef.requiresAgent || channelDef.canUseAgent) {
            let description = this.props.intl.formatMessage(messages.agentInvitationDescription, {productName: config.PRODUCT_NAME});

            if (channelDef.canUseAgent) {
                description = this.props.intl.formatMessage(messages.agentInvitationDescription2, {productName: config.PRODUCT_NAME});

                list[prefix + 'can-use-dativery-agent'] = {
                    name: this.props.intl.formatMessage(messages.useDativeryAgent, {productName: config.PRODUCT_NAME}),
                    type: "boolean",
                    defaultValue: false,
                    step: "1",
                };
            }

            list['agentInvitationId'] = {
                name: this.props.intl.formatMessage(messages.agentInvitationId),
                type: 'string',
                trim: true,
                isAuthInfo: false,
                isPerUser: false,
                description: description,
                defaultValue: this.state.invitationId || '',
                step: "1",
            };

            if (channelDef.canUseAgent) {
                list['agentInvitationId'].visibility = handleJavaScript("output = !!getValue(\"can-use-dativery-agent\");", null, true, prefix);
            }
        }

        let addLabel = !channelOptionDefs.some(item => item.type !== "boolean") && channelOptionDefs.length === 1;
        for (let opt of channelOptionDefs) {
            let description = "";
            Object.values(opt).forEach(value => {
                if (value === "") {
                    delete opt[key];
                }
            });
            if ((opt.internal || opt.disabled) && !BrowserPermission.isDeveloper()) {
                continue;
            }

            if (opt['description']) {
                description += opt['description'];
            }

            if (opt['examples']) {
                description += " " + this.props.intl.formatMessage(messages.example) + " " + opt['examples'];
            }

            let key = prefix + opt.key;

            list[key] = {
                name: opt['name'],
                type: opt['type'],
                trim: true,
                isAuthInfo: opt['isAuthInfo'] ? true : false,
                isPerUser: channelDef['authType'] === AUTH_TYPE_PER_USER && opt['isAuthIdentity'] ? true : false,
                descriptionHtml: description,
                defaultValue: opt.key in this.args ? this.args[opt.key] : opt['defaultValue'],
                step: opt['step'] || "1",
            };

            if (opt['type'] === 'js-action') {
                list[key]['onClick'] = () => {
                    return new Promise((resolve, reject) => {
                        try {

                            let {channel} = this.props.user.organisation;

                            let onSuccess = ({invokeChannelAction}) => {
                                if (invokeChannelAction.success && invokeChannelAction.response) {
                                    let response = JSON.parse(invokeChannelAction.response);
                                    if (response && response.downloadContent) {
                                        let blob = new Blob([response.downloadContent]);
                                        filesaver.saveAs(blob, response.downloadFileName || "dativery.txt", true);
                                    }
                                }
                            };
                            let onFailure = (transaction) => {
                                let error = mutationError(transaction);
                                reject(error);
                            };

                            let actionName = "channel-option-action";

                            let mutationArgs = {
                                channel: channel,
                                actionName: actionName,
                                args: {
                                    actionName: opt.key,
                                },
                            };

                            if (this.props.relay) {
                                this.props.relay.commitUpdate(
                                    new InvokeChannelActionMutation(mutationArgs), {onSuccess: onSuccess, onFailure: onFailure}
                                );
                            }
                        } catch (e) {
                            reject(e);
                        }
                    });
                };
            }

            if (addLabel) {
                list[key]['rowClassName'] = 'singleBoolean';
            }

            if (opt['regexp']) {
                list[key]['validations'] = {
                    matchRegexp: opt['regexp']
                };
            }

            if (opt['type'] === 'enum') {
                if (opt['enumValues']) {
                    let enumValues = safeJSONparse(opt['enumValues']);
                    let values = {};

                    for (let key of Object.keys(enumValues)) {
                        let value;

                        if (!enumValues[key]) {
                            value = {
                                name: key
                            };
                        } else if (typeof enumValues[key] === "string") {
                            value = {
                                name: enumValues[key]
                            };
                        } else {
                            value = enumValues[key];
                        }

                        values[key] = value;
                    }

                    list[key]['values'] = values;
                } else if (opt['datiQuery']) {
                    list[key]['datiQueryHasParameters'] = opt['datiQueryHasParameters'];
                    if (opt['datiQueryHasParameters']) {
                        list[key]['columnPrefixId'] = prefix;
                    }
                    list[key]['datiQuery'] = opt['datiQuery'];
                    let {channel} = this.props.user.organisation;

                    list[key]['channel_id'] = channel.realId;
                    list[key]['channelDef_id'] = opt.channelDef_id;
                    list[key]['organisation_id'] = this.props.user.organisation.realId;
                }
            }

            if (opt['isAuthInfo'] && originalData[key]) {
                list[key]['placeholder'] = this.props.intl.formatMessage(messages.filled);
            } else {
                /* filled auth information can't be marked as required (it is empty) */
                list[key]['required'] = opt['required'] ? true : false;
            }

            if (opt['prefix']) {
                list[key]['addonBefore'] = opt['prefix'];
            }
            if (opt['suffix']) {
                list[key]['addonAfter'] = opt['suffix'];
            }

            list[key]['accessType'] = opt['accessType'];
            list[key]['developersOnly'] = opt['developersOnly'];
            list[key]['partner1Only'] = opt['partner1Only'];
            list[key]['partner2Only'] = opt['partner2Only'];
            list[key]['internal'] = opt['internal'];

            if (opt['visibilityJS']) {
                list[key]['visibility'] = handleJavaScript(opt['visibilityJS'], null, true, prefix);
            }
        }

        this.metadataList = list;

        return declareEditEntity({
            entity: "options",
            graphQL: "Options",
            name: this.props.intl.formatMessage(messages.options),
            fields: (types) => {
                return list;
            }
        });
    }

    // eslint-disable-next-line max-params
    _submit = async (data) => {
        /* we have to find which options are authentication and which not */
        let {channel} = this.props.user.organisation;
        let channelDef = this.props.user.organisation.channel.channelDef;

        let prefix = this.getTypeKey(channelDef);

        let authData = {};

        for (let key of Object.keys(data)) {
            let val = data[key];

            if (val && this.metadataList[key] && (
                this.metadataList[key].type === 'certificate' ||
                this.metadataList[key].type === 'file'
            )) {
                if (val.length > 0) {
                    let file = val[0];

                    data[key] = await new Promise((resolve, reject) => { // eslint-disable-line no-await-in-loop
                        let reader = new FileReader();
                        reader.readAsArrayBuffer(file);
                        reader.onabort = reader.onerror = (e) => {
                            reject(e);
                        };
                        reader.onload = (evt) => {
                            resolve(btoa(String.fromCharCode(...new Uint8Array(evt.target.result))));
                        };
                    });
                }
            }
            if (val) {
                data[key] = String(data[key]).trim();
            }
        }

        for (let key of Object.keys(data)) {
            let val = data[key];

            if (val && this.metadataList[key] && this.metadataList[key]['isAuthInfo']) {
                authData[key] = val;
            }
        }

        let currentUserOptionsToStore = {};
        let optionsToStore = {};

        for (let key of Object.keys(data)) {
            let val = data[key];

            if (this.metadataList[key] && this.metadataList[key]['isAuthInfo']) {
                delete data[key];
            } else if (this.metadataList[key] && this.metadataList[key]['isPerUser']) {
                currentUserOptionsToStore[key] = val;
            } else {
                optionsToStore[key] = val;
            }
        }

        let promise = Promise.resolve();

        if (channelDef.canUseAgent && !data[prefix + 'can-use-dativery-agent'] && this.state.step === 1) {
            optionsToStore['agentLink'] = "";
            delete optionsToStore[prefix + 'can-use-dativery-agent'];

            if (channel['agentLink']) {
                promise = promise.then(() => {
                    return new Promise((resolve, reject) => {
                        Relay.Store.commitUpdate(
                            new AcceptLinkInvitationMutation({
                                'channel': channel,
                                'eraseInvitation': true,
                            }), {onSuccess: () => {
                                resolve();
                            }, onFailure: (err) => {
                                reject(err);
                            }}
                        );
                    });
                });
            }
        }

        if ((channelDef.requiresAgent || channelDef.canUseAgent) && (this.state.invitationId || data.agentInvitationId)) {
            let invitationId = this.state.invitationId || data.agentInvitationId;
            promise = promise.then(() => {
                return new Promise((resolve, reject) => {
                    Relay.Store.commitUpdate(
                        new AcceptLinkInvitationMutation({
                            'channel': channel,
                            'invitationId': invitationId,
                        }), {onSuccess: () => {
                            resolve();
                        }, onFailure: (err) => {
                            reject(err);
                        }}
                    );
                });
            });

        }
        delete data.agentInvitationId;

        if (Object.keys(authData).length > 0) {
            promise = promise.then(() => {
                return new Promise((resolve, reject) => {

                    Relay.Store.commitUpdate(
                        new UpdateChannelAuthMutation({
                            'channel': channel,
                            'authOptions': this.unmapKeys(channelDef, authData),
                        }), {onSuccess: () => {
                            resolve();
                        }, onFailure: (err) => {
                            reject(err);
                        }}
                    );
                });
            });
        }

        return promise.then(() => {
            return new Promise((resolve, reject) => {

                Relay.Store.commitUpdate(
                    new UpdateChannelConfigMutation({
                        'channel': channel,
                        'options': {...safeJSONparse(channel.options), ...this.unmapKeys(channelDef, optionsToStore)},
                        'currentUserOptions': {...safeJSONparse(channel.currentUserOptions), ...this.unmapKeys(channelDef, currentUserOptionsToStore)},
                    }), {onSuccess: (response) => {
                        response = response['updateChannelConfig'];
                        if (!response.success) {
                            this.setState({
                                hasConfigResult: true,
                                configFailureSuccess: response.success,
                                configFailureMessage: response.message,
                            });
                        } else {
                            this.setState({
                                hasConfigResult: false,
                                configFailureMessage: '',
                            });
                        }

                        resolve();
                    }, onFailure: (err) => {
                        reject(err);
                    }}
                );
            });
        }).then(() => {
            if (!this.state.hasConfigResult) {
                return this._onSuccess();
            }
        });
    };

    getNextCreateStep(channelDefMetadata, currentStep) {
        switch (getNextChannelCreateStep(channelDefMetadata, currentStep)) {
            case 3:
                return "create-step-3";
            case 4:
                return "create-step-4";
            case 5:
            default:
                return "create-step-5";
        }
    }

    _authTestDone(channel) {
        if (this.state.step === 1 && this.hasNextStep2()) {
            this.setState({
                authTestInProgress: false,
                step: 2
            });
            return;
        } else if ((this.state.step === 1 || this.state.step === 2 || this.state.step === 4) && (channel.activated === false || this.props.user.scenario)) {
            let args = {
                id: channel['id'],
                organisation_id: this.props.user.organisation['realId']
            };

            /* are we creating this channel as part of scenario? */
            let scenarioPrefix = "";
            if (this.props.user.scenario) {
                args['scenario_id'] = this.props.user.scenario['realId'];
                scenarioPrefix = "scenario-";
            }

            if (this.props.createCallback) {
                this.props.createCallback(channel);
                return;
            }

            const channelDefMetadata = safeJSONparse(channel?.channelDef?.metadata);
            const nextStep = this.getNextCreateStep(channelDefMetadata, this.state.step);
            let path = urlMapping.getUrl(types['channels'], scenarioPrefix + nextStep, args);
            this.context.router.push(path);
            return;
        } else if ((this.state.step === 1 || this.state.step === 2) && this.hasNextStep3()) {
            this.setState({
                authTestInProgress: false,
                step: 4,
            });
            return;
        }

        /* inform extension to reload its configuration */
        sendToExtension({
            message: 'dativery-reload',
        });

        let path = urlMapping.getUrl(types['channels'], "view", channel);
        this.context.router.push(path);
    }

    _onSuccess = () => {
        let {channel} = this.props.user.organisation;

        let metadata = safeJSONparse(channel.channelDef.metadata);
        if (metadata.hasAuthTest && !metadata.hasGrant) {
            this.setState({
                hasAuthTest: false,
                authTestInProgress: true
            });

            return new Promise((resolve, reject) => {
                let onSuccess = (response) => {
                    response = response['testChannelAuth'];
                    if (response.success) {
                        this._authTestDone(channel);
                    } else {
                        this.setState({
                            authTestInProgress: false,
                            hasAuthTest: true,
                            authFailureSuccess: response.success,
                            authFailureMessage: response.message,
                            fetch: response.fetch,
                            attempts: (this.state.attempts || 0) + 1,
                        });
                    }
                    resolve();
                };
                let onFailure = (transaction) => {
                    this.setState({
                        attempts: (this.state.attempts || 0) + 1,
                    });
                    mutationError(transaction);
                    reject();
                };

                Relay.Store.commitUpdate(
                    new TestChannelAuthMutation({
                        'channel': channel
                    }), {onSuccess: onSuccess, onFailure: onFailure}
                );

            });
        } else {
            this._authTestDone(channel);
        }
    };

    getFirstStep(props) {
        let allChannelOptionDefs = (props || this.props).user.organisation.channel.channelDef.allChannelOptionDefs;
        let minStep = 999;

        for (let {node} of allChannelOptionDefs.edges) {
            if (node.disabled || node.internal && !BrowserPermission.isDeveloper()) {
                continue;
            }
            let step = 1;
            if (node.step === CONFIG_STEP_1 || !node.step) {
                step = 1;
            } else if (node.step === CONFIG_STEP_2) {
                step = 2;
            } else if (node.step === CONFIG_STEP_3) {
                step = 4;
            }

            if (step < minStep) {
                minStep = step;
            }
        }

        if (minStep > 100) {
            minStep = this.props.step;
        }

        if (minStep < this.props.step) {
            minStep = this.props.step;
        }

        return minStep;
    }

    hasNextStep2() {
        let allChannelOptionDefs = this.props.user.organisation.channel.channelDef.allChannelOptionDefs;

        return Boolean(
            allChannelOptionDefs.edges.find(
                ({node}) => {
                    if (node.disabled || node.internal && !BrowserPermission.isDeveloper()) {
                        return false;
                    }

                    let fieldStep = node.step;

                    if (fieldStep === CONFIG_STEP_2) {
                        return true;
                    }

                    return false;
                }
            )
        );
    }

    hasNextStep3() {
        let allChannelOptionDefs = this.props.user.organisation.channel.channelDef.allChannelOptionDefs;

        return Boolean(
            allChannelOptionDefs.edges.find(
                ({node}) => {
                    if (node.disabled || node.internal && !BrowserPermission.isDeveloper()) {
                        return false;
                    }

                    let fieldStep = node.step;

                    if (fieldStep === CONFIG_STEP_3) {
                        return true;
                    }

                    return false;
                }
            )
        );
    }

    hasNextStep() {
        let allChannelOptionDefs = this.props.user.organisation.channel.channelDef.allChannelOptionDefs;

        return Boolean(
            allChannelOptionDefs.edges.find(
                ({node}) => {
                    if (node.disabled || node.internal && !BrowserPermission.isDeveloper()) {
                        return false;
                    }

                    let fieldStep = parseInt(node.step, 10);

                    if (this.state.step === 1 && isNaN(fieldStep)) {
                        return false;
                    }

                    return fieldStep > this.state.step;
                }
            )
        );
    }

    getColumns() {
        let columns = {};
        if (!this.metadata) {
            return columns;
        }

        let fieldsGetter = this.metadata._metadata.fields;
        let fields = typeof fieldsGetter === "function" ? fieldsGetter() : fieldsGetter;
        const isDeveloper = BrowserPermission.isDeveloper();
        const isPartner2 = BrowserPermission.isPartner2();
        const isPartner1 = BrowserPermission.isPartner1();

        Object.keys(fields).forEach(key => {
            let fieldStep = fields[key].step || CONFIG_STEP_1;

            let isOk = true;

            if ((
                (fields[key].developersOnly === true && !isDeveloper) || // ignore developer fields
                (fields[key].partner1Only === true && !isPartner1) || // ignore partner 1 fields
                (fields[key].partner2Only === true && !isPartner2) ||
                (fields[key].accessType === ACCESS_TYPE_DEVELOPER && !isDeveloper) ||
                (fields[key].accessType === ACCESS_TYPE_PARTNER1 && !isPartner1) ||
                (fields[key].accessType === ACCESS_TYPE_PARTNER2 && !isPartner2)
                )) {
                    isOk = false;
            }

            if (isOk && ((this.state.step === 1 && fieldStep === CONFIG_STEP_1) ||
                        this.state.step === 2 && fieldStep === CONFIG_STEP_2 ||
                        this.state.step === 4 && fieldStep === CONFIG_STEP_3)) {
                columns[key] = {};
            }
        });

        if (Instanced.isInstanced() && this.instanceFuncs.ChannelOptionEditRendererEditorColumns) {
            columns = this.instanceFuncs.ChannelOptionEditRendererEditorColumns({
                columns: columns,
                metadataFields: fields
            });
        }

        return columns;
    }

    renderPrototype() {
        let {channel} = this.props.user.organisation;
        let channelDef = channel.channelDef;
        let type = types['channelDefs'];

        let options = this.originalOptions;

        if (!this.metadata) {
            this.prepareMetaData();
        }

        let metadata = this.metadata;
        let columns = this.getColumns();
        let fetchListUrl = urlMapping.getUrl('fetches', 'list', {
            organisation_id: channel.organisation_id,
            id: channel.realId || channel.id,
        });

        let connectRequirement = null;
        if (channelDef.connectRequirement) {
            connectRequirement = Tool.getFormatted(type, 'connectRequirement', this.props.intl.formatMessage, channelDef);
        }
        if (channelDef.requiresAgent) {
            connectRequirement = (<span><FormattedMessage defaultMessage="Requires installation of {agentLink}." id="channelDef.requiresAgentUrl" values={{
                productName: config.PRODUCT_NAME,
                agentLink: <AgentLink />
            }} /> {connectRequirement}</span>);
        }

        if (channelDef.canUseAgent) {
            connectRequirement = (<span><FormattedMessage defaultMessage="Can use installation of {agentLink} to simplify network configuration." id="channelDef.canUseAgentUrl" values={{
                productName: config.PRODUCT_NAME,
                agentLink: <AgentLink />
            }} /> {connectRequirement}</span>);
        }

        let description = <FormattedMessage defaultMessage="Some services needs activation before we can apply this scenario" id="channelWizard.activationDescription" />;
        let wizzardTitle = <FormattedMessage defaultMessage="Scenario activation" id="channelWizard.activationHeader" />;
        let editor;


        if (editor === undefined) {
            editor = (<EditorWithSubmit
                buttonTitle={this.props.intl.formatMessage(this.hasNextStep() ? messages.next : this.props.wrapper ? messages.connect : messages.save)}
                cancel={this.props.cancel}
                columns={columns}
                data={options}
                isCreate={Object.keys(options).length === 0}
                metadata={metadata}
                onSuccess={this._onSuccess}
                submit={this._submit}
                urlMapping={urlMapping}
            >
                {this.state.authTestInProgress ? <p><strong className="verifyingSpinner"><span className="fa fa-spin fa-spinner"/> <FormattedMessage defaultMessage="Verifying authentication data"
                    id="channelOptionEdit.authTestInProgress"/></strong></p> : null}
                    {this.state.hasAuthTest ? <div className="bs-callout bs-callout-danger">
                        <strong style={{color: 'red'}}>
                            <FormattedMessage defaultMessage="Authentication test failed with error '{message}'. Check your credentials and try again."
                                id="channelOptionEdit.authFailed"
                                values={{
                                    message: this.state.authFailureMessage ? this.state.authFailureMessage : "",
                                }}
                            />
                        </strong>
                        <div className="performed-api-technical">
                            <FormattedMessage defaultMessage="Technical information:" id="channelWizard.fetchDescription" />{" "}
                            {this.state.fetch ?
                                <Link to={urlMapping.getUrl('fetches', 'view', this.state.fetch)}><FormattedMessage defaultMessage="Analyze performed API call" id="channelWizard.fetchLink" /></Link> :
                                <Link to={fetchListUrl}><FormattedMessage {...messages.fetchListLink} /></Link>
                            }
                        </div>

                        {this.state.attempts >= 3 ? <div><LoadingButton className="btn btn-danger" onClick={() => this._authTestDone(channel)} style={{"marginTop": "1em"}} type="button"><FormattedMessage defaultMessage="Save settings anyway" id="channelWizard.saveWithoutAuth" /></LoadingButton></div> : null}
                    </div> : null}
                    {this.state.hasConfigResult ? <div className="bs-callout bs-callout-danger">
                        <strong style={{color: 'red'}}>
                            <FormattedMessage defaultMessage="Configuration failed with error '{message}'."
                                id="channelOptionEdit.configFailed"
                                values={{
                                    message: this.state.configFailureMessage ? this.state.configFailureMessage : "",
                                }}
                            />
                        </strong>
                        <div className="performed-api-technical">
                            <FormattedMessage defaultMessage="Technical information:" id="channelWizard.fetchDescription" />{" "}
                            {this.state.fetch ?
                                <Link to={urlMapping.getUrl('fetches', 'view', this.state.fetch)}><FormattedMessage defaultMessage="Analyze performed API call" id="channelWizard.fetchLink" /></Link> :
                                <Link to={fetchListUrl}><FormattedMessage {...messages.fetchListLink} /></Link>
                            }
                        </div>
                    </div> : null}

            </EditorWithSubmit>);
        }

        let header = (<h2><div className="channelAdd-logo"><ChannelIcon channelDef={channelDef} size={128}/></div> {channelDef.name}</h2>);

        if (Instanced.isInstanced() && this.instanceFuncs && this.instanceFuncs.ChannelOptionEditRendererHeader) {
            header = this.instanceFuncs.ChannelOptionEditRendererHeader({
                channelDef: channelDef
            });
        }

        let content = (<div>
            {header}

            <div className="channelConnectInfo">
                {connectRequirement ? <p className="connect-requirement"><strong>{Tool.getLabel(type, 'connectRequirement', this.props.intl.formatMessage)}:</strong> {connectRequirement}</p> : null}

                {options.length > 1 || options.length > 0 && channelDef.requiresAgent === false ?
                    <p><FormattedMessage defaultMessage="Please provide information requested below to start using {channelName} with {productName}. We will quickly connect to your service. We recommend to use an account specific for our service only."
                                        id="channelOptionEdit.description1"
                                        values={{
                                        channelName: channelDef.name,
                                        productName: config.PRODUCT_NAME
                                    }}
                    /></p>
                : null}

                <p><FormattedHTMLMessage defaultMessage="Before you give your consent, see <a href=&quot;{url}&quot;>how secure {productName} is</a>."  id="channelOptionEdit.description2" values={{productName: config.PRODUCT_NAME, channelDefKey: channelDef.name, url: 'https://www.dativery.com/' + getLocale() + '/security/'}} /></p>

                {this.props.user.organisation && this.props.user.organisation.users.edges.length > 1 && channelDef.authType !== AUTH_TYPE_PER_USER ? <p className="perUserNote"><strong><FormattedMessage defaultMessage="Note:" id="channel.note" /></strong> <FormattedMessage defaultMessage="by connecting {app} you will allow access for all other users in this organisation too." id="channel.warningExplanation" values={{app: channelDef.name}}/></p> : null}
            </div>

            {editor}
        </div>);

        if (this.props.wrapper) {
            return content;
        }

        return (
            <AppPanel breadcrumbParams={[
                {type: types['channels'], data: channel},
                {type: types['scenarios'], data: this.props.user.scenario},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <ScenarioWizard data={this.props.user} description={description} step={1} title={wizzardTitle} type={type}>
                    {content}
                </ScenarioWizard>
            </AppPanel>
        );
    }

    render() {
        this.prepareMetaData();

        return this.renderPrototype();
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(ChannelOptionEdit), (props) => {
    return props.user.organisation && props.user.organisation.channel;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        scenarioId: '',
        scenarioSelected: false,
    },
    prepareVariables (variables) {
        if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        variables['scenarioSelected'] = variables['scenarioId'] ? true : false;

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                scenario(id: $scenarioId) @include(if: $scenarioSelected) {
                    id,
                    realId,
                    ${ScenarioBoxAsWizard.getFragment('scenario')},
                    ${ScenarioIcon.getFragment('scenario')}
                },
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    users(first: 2) {
                        edges {
                            node {
                                id,
                                realId
                            }
                        }
                    },
                    ${ScenarioBoxAsWizard.getFragment('organisation')},
                    channel(id: $channelId) {
                        ${AcceptLinkInvitationMutation.getFragment('channel')}
                        ${UpdateChannelConfigMutation.getFragment('channel')}
                        ${TestChannelAuthMutation.getFragment('channel')}
                        ${UpdateChannelAuthMutation.getFragment('channel')}
                        id,
                        realId,
                        channelDef_id,
                        agentLink,
                        organisation_id,
                        activated,
                        channelDef {
                            id,
                            name,
                            type,
                            authType,
                            metadata,
                            connectRequirement,
                            requiresAgent,
                            canUseAgent,
                            icon,
                            realId,
                            allChannelOptionDefs(first: 100) {
                                edges {
                                    node {
                                        id,
                                        key,
                                        name,
                                        type,
                                        required,
                                        disabled,
                                        internal,
                                        step,
                                        isAuthInfo,
                                        isAuthIdentity,
                                        description,
                                        examples,
                                        enumValues,
                                        datiQuery,
                                        datiQueryHasParameters,
                                        fileContentTypes,
                                        visibilityJS,
                                        defaultValue,
                                        accessType,
                                        prefix,
                                        suffix,
                                        regexp
                                    }
                                }
                            }
                        },
                        type,
                        options,
                        currentUserOptions,
                        authOptions,
                        name,
                        enabled
                    }
                },
            }
        `,
    },
});
